import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';

import CustomPaginator from '../../../common/CustomPaginator';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import exportIcon from '../../../../assets/export';
import saveFileIcon from '../../../../assets/saveFileIcon';

import { Alert } from '@material-ui/lab';
import { IconButton, Table, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import downarrowIcon from '../../../../assets/downArrow';
import './CSDesktop.scss';
import iObjCSService from 'src/services/claimStatus/claimStatusService';

import MUIDataTable, {
  Responsive,
  TableBody,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow
} from 'mui-datatables';

import Button from '@material-ui/core/Button';
import { Fade, Menu, MenuItem } from '@material-ui/core';
import InvoiceService from 'src/services/invoice';
import LocaleFormating from 'src/translation/localeFormating';
import { downloadFile } from 'src/utils/downloadHelper';
import theme from '../../../../themes/theme';
import { disableScroll, enableScroll } from 'src/utils/documentInteraction';
import { currencyFormatter } from 'src/utils/currencyFormatter';

import * as _ from 'lodash';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

import EmailIcon from 'src/assets/emailIcon';
import { FunctionComponent } from 'react';
import ClaimStatusModel from 'src/model/ClaimStatus.model';

import html2PDF from 'jspdf-html2canvas';
import { jsPDF } from 'jspdf';
import * as $ from 'jquery';
import autoTable from 'jspdf-autotable';
import * as ReactDOMServer from 'react-dom/server';
import Modal from 'src/components/common/Modal/Modal';
import EmailInvoicesApplyCreditModel from 'src/components/Invoices/components/EmailInvoicesApplyCreditModel';
import EmailClaimsModal from '../EmailClaimsModal';
import ClaimDetailsModel from 'src/model/ClaimDetails.model';
// import * as XLSX from 'xlsx';

interface ICSExpTblProps {
  csHistoryData: ClaimStatusModel[];
  ExptOption: string;
  csColumns: any[];
  SltClaims: ClaimStatusModel[];
  csPartExpCols: any[];
}

export const CSExpTblCmpt: FunctionComponent<ICSExpTblProps> = ({
  csHistoryData,
  ExptOption,
  csColumns,
  SltClaims,
  csPartExpCols
}) => (
  <>
    {ExptOption && ExptOption === 'pdf' && (
      <div style={{ width: '100%', textAlign: 'center' }}>
        <table
          id="tblExpt"
          className="tblExport"
          cellPadding={10}
          cellSpacing={10}
          style={{
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            width: '100%',
            border: '0px solid #000'
          }}
        >
          <tbody>
            {csHistoryData.map((row: any) => (
              <>
                <tr>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((thr: any) => (
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'center',
                          backgroundColor: '#f2f2f2',
                          width: '25%',
                          fontWeight: 'bold'
                        }}
                      >
                        {thr.label}
                      </th>
                    ))}
                </tr>
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td style={{ padding: '10px', textAlign: 'center' }}>
                        {row[col.name]}
                      </td>
                    ))}
                </tr>
                <tr>
                  <td
                    colSpan={
                      csColumns.filter(p => p.options.display === true).length
                    }
                    style={{ padding: '0px', borderBottom: '1px solid #000' }}
                  >
                    <table style={{ border: '1px solid #000', width: '100%' }}>
                      <thead>
                        <tr style={{ border: '1px solid #000' }}>
                          {csPartExpCols.map((col: any) => (
                            <th
                              style={{
                                padding: '10px',
                                textAlign: 'center',
                                backgroundColor: '#f2f2f2'
                              }}
                            >
                              {col.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {row.csPartDetails.map((cspart: any) => (
                          <tr key={cspart.id}>
                            {csPartExpCols.map((col: any) => (
                              <td
                                style={{
                                  padding: '10px',
                                  textAlign: 'center'
                                }}
                              >
                                {col.fVal && col.fVal === 'C' && (
                                  <>{currencyFormatter(cspart[col.value])}</>
                                )}
                                {!col.fVal && <>{cspart[col.value]}</>}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    )}
    {ExptOption && ExptOption === 'pdf1' && (
      <div id="dvExpt" style={{ width: '100%', textAlign: 'center' }}>
        {csHistoryData.map((row: any, idx: number) => (
          <>
            <table
              key={row.id}
              id={'tblCSExpt' + idx}
              className="tblExport"
              cellPadding={10}
              cellSpacing={10}
              style={{
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                width: '100%',
                border: '0px solid #000'
              }}
            >
              <thead>
                <tr>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((thr: any) => (
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'center',
                          backgroundColor: '#f2f2f2',
                          width: '25%',
                          fontWeight: 'bold'
                        }}
                      >
                        {thr.label}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td style={{ padding: '10px', textAlign: 'center' }}>
                        {row[col.name]}
                      </td>
                    ))}
                </tr>
              </tbody>
            </table>
            <table
              key={row.id}
              id={'tblCSPExpt' + idx}
              className="tblExport"
              cellPadding={10}
              cellSpacing={10}
              style={{
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                width: '100%',
                border: '1px solid #000'
              }}
            >
              <thead>
                <tr style={{ border: '1px solid #000' }}>
                  {csPartExpCols.map((col: any) => (
                    <th
                      style={{
                        padding: '10px',
                        textAlign: 'center',
                        backgroundColor: '#f2f2f2'
                      }}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {row.csPartDetails.map((cspart: any) => (
                  <tr key={cspart.id}>
                    {csPartExpCols.map((col: any) => (
                      <td
                        style={{
                          padding: '10px',
                          textAlign: 'center'
                        }}
                      >
                        {col.fVal && col.fVal === 'C' && (
                          <>{currencyFormatter(cspart[col.value])}</>
                        )}
                        {!col.fVal && <>{cspart[col.value]}</>}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ))}
      </div>
    )}
    {ExptOption && ExptOption === 'xlsx' && (
      <table id="tblExpt" className="tblExport">
        <thead>
          <tr>
            {csColumns
              .filter(p => p.options.display === true)
              .map((row: any) => (
                <th
                  style={{
                    padding: '10px',
                    textAlign: 'center',
                    backgroundColor: '#f2f2f2',
                    border: '1px solid #000'
                  }}
                >
                  {row.label}
                </th>
              ))}

            {csPartExpCols.map((col: any) => (
              <th
                style={{
                  padding: '10px',
                  textAlign: 'center',
                  backgroundColor: '#f2f2f2',
                  border: '1px solid #000'
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {csHistoryData.map((row: any) => (
            <>
              {row.csPartDetails && row.csPartDetails.length === 0 && (
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td
                        style={{
                          padding: '10px',
                          textAlign: 'center',
                          border: '1px solid #000'
                        }}
                      >
                        {row[col.name]}
                      </td>
                    ))}

                  {csPartExpCols.map((col: any) => (
                    <td
                      style={{
                        padding: '10px',
                        textAlign: 'center',
                        border: '1px solid #000'
                      }}
                    >
                      &nbsp;
                    </td>
                  ))}
                </tr>
              )}

              {row.csPartDetails.map((cspart: any) => (
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td
                        style={{
                          padding: '10px',
                          textAlign: 'center',
                          border: '1px solid #000'
                        }}
                      >
                        {row[col.name]}
                      </td>
                    ))}

                  {csPartExpCols.map((col: any) => (
                    <td
                      style={{
                        padding: '10px',
                        textAlign: 'center',
                        border: '1px solid #000'
                      }}
                    >
                      {col.fVal && col.fVal === 'C' && (
                        <>{currencyFormatter(cspart[col.value])}</>
                      )}
                      {!col.fVal && <>{cspart[col.value]}</>}
                    </td>
                  ))}
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>
    )}
    {ExptOption && ExptOption === 'csv' && (
      <table id="tblExpt" className="tblExport">
        <thead>
          <tr>
            {csColumns
              .filter(p => p.options.display === true)
              .map((row: any) => (
                <th>{row.label}</th>
              ))}
            {csPartExpCols.map((col: any) => (
              <th>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {csHistoryData.map((row: any) => (
            <>
              {row.csPartDetails && row.csPartDetails.length.length === 0 && (
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td>{row[col.name]}</td>
                    ))}

                  {csPartExpCols.map((col: any) => (
                    <td>&nbsp;</td>
                  ))}
                </tr>
              )}

              {row.csPartDetails.map((cspart: any) => (
                <tr key={row.id}>
                  {csColumns
                    .filter(p => p.options.display === true)
                    .map((col: any) => (
                      <td>{row[col.name]}</td>
                    ))}

                  {csPartExpCols.map((col: any) => (
                    <td>
                      {col.fVal && col.fVal === 'C' && (
                        <>{currencyFormatter(cspart[col.value])}</>
                      )}
                      {!col.fVal && <>{cspart[col.value]}</>}
                    </td>
                  ))}
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>
    )}
  </>
);

export default function CSDesktop(props: any) {
  const [pagenumber, setPagenumber] = React.useState(0);
  const [pagesize, setPageSize] = React.useState(20);
  const [rowscount, setRowscount] = React.useState([]);
  const [totalItems, setTotalItems] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [csHistoryData, setClaimStatusHistoryData] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [apiLoader, handleApiLoader] = React.useState(false);
  const [showLoaderOnAction, setShowLoaderOnAction] = React.useState(false);
  const [allSelectedData, setAllSelectedData] = React.useState([]);
  const [csPDFAvailData, setcsPDFAvailData] = React.useState([]);
  const [rowsExpandedList, setRowsExpandedList] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [showInvoiceError, setShowInvoiceError] = React.useState(false);
  const [numberOfRowsPerPage, setNumberOfRowsPerPage] = React.useState(20);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [hideBtnShowError, setHideBtnShowError] = React.useState(false);
  const [showPaymentError, setShowPaymentError] = React.useState(false);
  const [showEmailError, setshowEmailError] = React.useState(false);
  const [showSaveError, setshowSaveError] = React.useState(false);
  const [showEmailmsg, setshowEmailmsg] = React.useState(false);
  const [showNoClaimsError, setshowNoClaimsError] = React.useState(false);
  const [noclaims, setNoClaims] = React.useState([]);
  const [displayState, setDisplayState] = React.useState([]);
  const [childcheckState, setchildcheckState] = React.useState([false]);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [sortOrderState, setSortOrderState] = React.useState({
    name: 'paymentDate',
    direction: 'desc'
  });
  const [
    removeClaimsFromSelected,
    setRemoveClaimsFromSelected
  ] = React.useState([]);
  const [checked, setChecked]: any = React.useState([]);
  const [parentchecked, setparentChecked]: any = React.useState([false]);
  const all = [...checked];
  const [count, setCount] = React.useState(false);

  const [gridDataNotFound, setGridDataNotFound] = React.useState('');

  const [setcResubmitDetails, SetResubmitClaim] = props;
  // const [cResubmitDetails, setcResubmitDetails] = React.useState();
  const [errormsg, seterrormsg] = React.useState('');
  const [ExptOption, setExptOption] = React.useState('');
  const [uCSCPDetails, setCSCPDetails] = React.useState(false);
  const [uCSCPagesize, setUCSCPagesize] = React.useState(false);
  /* if (props.pagination === null) {
    props.pagination = { pageNumber: 0, totalPages: 1, pageSize: 20 };
  } */
  // console.log(props);

  function ResetFilterMsgs() {
    setShowLoaderOnAction(false);
    setshowNoClaimsError(false);
    setModalIsOpen(false);
    seterrormsg('');
    setshowEmailError(false);
    setshowEmailmsg(false);
    setAllSelectedData([]);
    setCount(false);
    setChecked([]);
    setRowscount([]);
  }
  React.useEffect(() => {
    if (uCSCPDetails) {
      const { filtervalues, pagination } = props;
      const gpg = { pageNumber: 0, totalPages: 1, pageSize: 20 };
      gpg.pageNumber = pagenumber;
      gpg.pageSize = pagesize;

      ResetFilterMsgs();

      // console.log('CS Desktop - Data Loading', props.filtervalues);
      // alert("Show loader");
      handleApiLoader(true);
      if (props.filtervalues && props.filtervalues.csSearchKey) {
        // setGridDataNotFound("claimStatus.DataNotFound02");
        gridOptions.textLabels.body.noMatch = i18n.t(
          'claimStatus.DataNotFound01'
        );
      } else {
        // setGridDataNotFound('claimStatus.DataNotFound02');
        gridOptions.textLabels.body.noMatch = i18n.t(
          'claimStatus.DataNotFound02'
        );
      }

      const activeAccount = localStorage.getItem('activeAccount');
      if (props.filtervalues) {
        iObjCSService
          .getClaimStatusHistory(activeAccount, props.filtervalues, gpg)
          .then((response: any) => {
            // console.log(response.data);
            const resData = response.data;
            setClaimStatusHistoryData(resData);
            handleApiLoader(false);
            setCSCPDetails(false);
          })
          .catch((error: any) => {
            // console.log(error);
            // handleApiLoader(false);
            // removeColumnOrganiser();
            setClaimStatusHistoryData([]);
          });
      }
    }
  }, [uCSCPDetails]);
  React.useEffect(() => {
    const { filtervalues, pagination } = props;

    const gpg = { pageNumber: 0, totalPages: 1, pageSize: 20 };
    setPagenumber(0);
    gpg.pageNumber = 0;
    gpg.pageSize = pagesize;

    ResetFilterMsgs();

    // console.log('CS Desktop - Data Loading', props.filtervalues);
    // alert("Show loader");
    handleApiLoader(true);
    if (props.filtervalues && props.filtervalues.csSearchKey) {
      // setGridDataNotFound("claimStatus.DataNotFound02");
      gridOptions.textLabels.body.noMatch = i18n.t(
        'claimStatus.DataNotFound01'
      );
    } else {
      // setGridDataNotFound('claimStatus.DataNotFound02');
      gridOptions.textLabels.body.noMatch = i18n.t(
        'claimStatus.DataNotFound02'
      );
    }

    const activeAccount = localStorage.getItem('activeAccount');
    if (props.filtervalues) {
      iObjCSService
        .getClaimStatusHistory(activeAccount, props.filtervalues, gpg)
        .then((response: any) => {
          // console.log(response.data);
          const resData = response.data;

          // props.pagination.totalItems=response.totalClaims;
          setTotalItems(response.totalClaims);
          setTotalPages(response.totalPages);

          setClaimStatusHistoryData(resData);
          handleApiLoader(false);
          setUCSCPagesize(false);
        })
        .catch((error: any) => {
          // console.log(error);
          // handleApiLoader(false);
          // removeColumnOrganiser();
          setClaimStatusHistoryData([]);
        });
    }
  }, [props.filtervalues, uCSCPagesize]);

  React.useEffect(() => {
    // removeColumnOrganiser();
  }, [csHistoryData]);
  React.useEffect(() => {
    // console.log("Default");
    if (!_.isEqual(columns, columns1)) {
      setColumns(columns1);
    }
  }, []);
  function getAmountFixedValue(amount: any) {
    const amountVal = Number(amount);
    if (amountVal) {
      return `$${amountVal.toFixed(2)}`;
    }
    return '$0.00';
  }

  function checkValue(value: any) {
    if (value) {
      return value;
    }
    return '-';
  }

  function getDateFormat(date: any) {
    if (date) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return month + '/' + day + '/' + year;
    }
    return '-';
  }
  function getdownLoadDateFormat(date: any) {
    if (date) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return year + '-' + month + '-' + day;
    }
    return '-';
  }
  function handleOriginalinvoice(
    e: any,
    invoiceNo: string,
    invoiceDate: string,
    paymentReference: string,
    checkindex: any,
    parentindex: any
  ) {
    const clickedCategory = checked.indexOf(invoiceNo);

    let obj: any = [];
    const newArr = [...csHistoryData];

    if (clickedCategory === -1 && e.target.checked) {
      obj = {
        invoiceNo,
        invoiceDate
      };
      setCount(true);
      newArr[parentindex].isSelected = true;
      newArr[parentindex].csPartDetails[checkindex].checkedstatus = true;
      newArr[parentindex].csPartDetails[checkindex].Ischeckedind = '';
      all.push(obj);
    } else {
      all.splice(obj.invoiceNo, 1);
      setCount(false);
      newArr[parentindex].isSelected = false;
      newArr[parentindex].csPartDetails[checkindex].checkedstatus = false;
      newArr[parentindex].csPartDetails[checkindex].Ischeckedind = 'unchecked';
    }
    setChecked(all);
    setClaimStatusHistoryData(newArr);
  }

  function handleOriginalinvoicebulk(
    invoiceNo: string,
    invoiceDate: string,

    allrowselection: any
  ) {
    let bulkobj: any = [];
    const checkarr: any = [];
    const filteredarr: any = [];
    const newArr = [...csHistoryData];
    newArr.map(newarrval =>
      newarrval.csPartDetails.forEach(
        (mapvalue: any) => ((mapvalue.checkedstatus = false), newArr),
        ((newarrval.isSelected = false), (newarrval.indvalchecked = ''))
      )
    );

    allrowselection.map((indexvalue: any) => {
      newArr[indexvalue.dataIndex].csPartDetails.forEach((mapval: any) => {
        if (mapval.Ischeckedind === '') {
          mapval.checkedstatus = true;
        }

        newArr[indexvalue.dataIndex].isSelected = true;
        newArr[indexvalue.dataIndex].indvalchecked = 'checked';
        bulkobj = {
          invoiceNo,
          invoiceDate
        };

        all.push(bulkobj);
      });
    });
    newArr.forEach((val: any, index: any) => {
      val.csPartDetails.forEach((valmap: any) => {
        if (valmap.Ischeckedind === 'unchecked' && val.indvalchecked === '') {
          valmap.Ischeckedind = '';
        }
      });
    });

    all.map((invno: any) => {
      const checklist = checkarr.filter(
        (invfil: any) => invfil.invoiceNo === invno.invoiceNo
      );
      if (checklist.length === 0) {
        checkarr.push({
          invoiceNo: invno.invoiceNo,
          invoiceDate: invno.invoiceDate
        });
      }
    });

    setChecked(checkarr);

    setClaimStatusHistoryData(newArr);
  }

  function resetSubtable() {
    const resetarr = [...csHistoryData];
    resetarr.map(resetvalue => {
      // console.log('resetSubtable');
      /* (resetvalue.isSelected = false),
        resetvalue.mappedPayment.forEach(
          (checkreset: any) => (checkreset.checkedstatus = false)
        );
        */
    });
  }

  const CustomToolbar = () => {
    return (
      <div className="select-credits margintb10px">
        <div className="d-flex selected-items">
          <div className="d-flex number-of-items">
            <span className="items">
              {allSelectedData.length} Claim(s) selected{' '}
            </span>
            <span className="mobile-view">
              {allSelectedData.length} Claim(s) selected{' '}
            </span>
            <span className="clear-mg " onClick={clearClick}>
              clear
            </span>
          </div>
        </div>
      </div>
    );
  };

  const CustomToolbar1 = () => {
    return (
      <div className="select-credits margintb10px">
        <div className="d-flex selected-items">
          <div className="d-flex number-of-items">
            <span className="items">{checked.length} invoice(s) selected </span>
            <span className="mobile-view">
              {checked.length} invoice(s) selected{' '}
            </span>
            <span className="clear-mg " onClick={clearClickInvoice}>
              clear
            </span>
          </div>
        </div>
      </div>
    );
  };

  const clearClick = () => {
    setRowscount([]);
    setAllSelectedData([]);
  };
  function clearClickInvoice() {
    setCount(false);
    setChecked([]);
    resetSubtable();
  }
  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    // setRowscount(rowsSelectedpath);
    setshowEmailError(false);
    setshowEmailmsg(false);
    const allSelections: any[] = [];
    if (currentRowsSelected.length === 0) {
      setRowscount([]);
      setAllSelectedData([]);
      setCount(false);
      setChecked([]);
      resetSubtable();
    } else {
      setRowscount(rowsSelectedpath);
      rowsSelectedpath.map((index: any) => {
        // const index=currentRowsSelected[0].index
        if (csHistoryData.length > 0) {
          // Todo - Set Selected Claim & Part Details Information
          /* const obj = {
            amountPaid: csHistoryData[index].amountPaid,
            invoiceDate: csHistoryData[index].invoiceDate,
            invoiceDescription: csHistoryData[index].invoiceDescription,
            invoiceNumber: csHistoryData[index].invoiceNumber,
            number: csHistoryData[index].number,
            orderNumber: csHistoryData[index].orderNumber,
            paymentDate: csHistoryData[index].paymentDate,
           paymentReference: csHistoryData[index].paymentReference,
            paymentType: csHistoryData[index].paymentType,
            purchaseOrder: csHistoryData[index].purchaseOrder,
            remainingAmount: csHistoryData[index].remainingAmount,
            totalAmount: csHistoryData[index].totalAmount,
            transactionId: csHistoryData[index].transactionId,
            mappedPayment: csHistoryData[index].mappedPayment
          }; */
          allSelections.push(csHistoryData[index]);
          /* obj.mappedPayment.forEach((datainfo: any, indexvalue: any) => {
            handleOriginalinvoicebulk(
              datainfo.invoiceNumber,
              datainfo.invoiceDate,
              allRowsSelected
            );
          }); */
        }
      });
      setAllSelectedData(allSelections);

      resetindividual(allSelections, allRowsSelected);
    }
  };

  function GetExportClaimDetails() {
    if (allSelectedData && allSelectedData.length > 0) {
      return allSelectedData;
    } else {
      return csHistoryData;
      /* const { filtervalues, pagination } = props;
      
      handleApiLoader(true);
      if (props.filtervalues && props.filtervalues.csSearchKey) {
        // setGridDataNotFound("claimStatus.DataNotFound02");
        gridOptions.textLabels.body.noMatch = i18n.t(
          'claimStatus.DataNotFound01'
        );
      } else {
        // setGridDataNotFound('claimStatus.DataNotFound02');
        gridOptions.textLabels.body.noMatch = i18n.t(
          'claimStatus.DataNotFound02'
        );
      }
      
      const activeAccount = localStorage.getItem('activeAccount');
      if (props.filtervalues) {
        iObjCSService
          .getClaimStatusHistory(activeAccount, props.filtervalues,props.pagination)
          .then((response: any) => {
            // console.log(response.data);
            const resData = response.data;
            return resData;           
            handleApiLoader(false);
          })
          .catch((error: any) => {
            return [];
          });
      }
      return [];*/
    }
  }

  function resetindividual(allSelections: any, allRowsSelected: any) {
    const filteredarr: any = [];
    const newArr = [...csHistoryData];
    if (allSelections.length !== 0) {
      // Todo - Set Selected Claims Details
      allSelections.forEach((selecteditem: any) => {
        // console.log(selecteditem);
        /* selecteditem.mappedPayment.forEach((mappeditem: any) => {
          if (mappeditem.Ischeckedind === '') {
            filteredarr.push({
              invoiceNo: mappeditem.invoiceNumber,
              invoiceDate: mappeditem.invoiceDate
            });
          }
        })*/
      });
    } else {
      setCount(false);
      setChecked([]);
      resetSubtable();
      // Todo - Set Selected Claims Details
      /* newArr.forEach((val: any, index: any) => {
         val.mappedPayment.forEach((valmap: any) => {
           if (
             valmap.Ischeckedind === 'unchecked' &&
             val.indvalchecked === 'checked'
           ) {
             valmap.Ischeckedind = '';
             val.indvalchecked = '';
           }
         });
       });*/
    }

    setChecked(filteredarr);
    setClaimStatusHistoryData(newArr);
  }
  const setCSGridColDisplayStatus = (colName: string, dStatus: string) => {
    const csList = localStorage.getItem('csDColList');

    let cIndex: number = -1;
    let csCols = csList.split(',');
    if (dStatus === 'add') {
      if (csCols.find(p => p === colName)) {
        csCols = csCols.filter(p => p !== colName);
        cIndex = columns1.findIndex(p => p.name === colName);
        if (cIndex > -1) {
          columns1[cIndex].options.display = true;
        }
        // columns1[""].options.disabled=
      }
    } else {
      if (!csCols.find(p => p === colName)) {
        csCols.push(colName);
        cIndex = columns1.findIndex(p => p.name === colName);
        if (cIndex > -1) {
          columns1[cIndex].options.display = false;
        }
      }
    }
    setColumns(columns1);
    // console.log(columns1);
    // console.log(csCols.join(","));
    localStorage.setItem('csDColList', csCols.join(','));
  };
  const checkDisplayState = (
    fileldName: string,
    state: boolean,
    isUpdate: boolean
  ) => {
    let csDColList = localStorage.getItem('csDColList');
    if (csDColList === null) {
      localStorage.setItem('csDColList', '');
    }
    csDColList = localStorage.getItem('csDColList');
    // console.log(csDColList);
    const csColDStatus = csDColList.split(',').find(p => p === fileldName)
      ? false
      : true;
    return csColDStatus;
  };

  const columns1 = [
    {
      label: `${i18n.t('CSReport.ClaimNo')}`,
      name: 'claimNo',
      options: {
        display: true,
        viewColumns: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              <span
                className="invoice-under-line"
                onClick={() => onClickPaymentReference(value)}
              >
                {value}
              </span>
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('CSReport.ClaimType')}`,
      name: 'claimType',
      options: {
        display: checkDisplayState('claimType', true, false)
      }
    },
    {
      label: `${i18n.t('CSReport.DateSubmitted')}`,
      name: 'claimSubmitted',
      options: {
        sortDirection: 'desc',
        display: checkDisplayState('claimSubmitted', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return <>{value}</>;
        }
      }
    },
    {
      label: `${i18n.t('CSReport.CSOriInvNo')}`,
      name: 'claimOriInvNo',
      options: {
        display: 'excluded',
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              <span
                className="claim-desktop-row-line"
                onClick={() => onClickInvoiceNo(value)}
              >
                {value}
              </span>
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('CSReport.SourceOfClaim')}`,
      name: 'claimSource',
      options: {
        display: checkDisplayState('claimSource', true, false)
      }
    },
    {
      label: `${i18n.t('CSReport.ClaimStatus')}`,
      name: 'claimStatus',
      options: {
        display: checkDisplayState('claimStatus', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return <>{value}</>;
        }
      }
    },
    {
      label: `${i18n.t('CSReport.ReasonForRejection')}`,
      name: 'cRejectReason',
      options: {
        display: 'excluded',
        // display: checkDisplayState('cRejectReason', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return <>{value}</>;
        }
      }
    },
    {
      label: 'Claim Number',
      name: 'claimNo',
      options: { display: 'excluded' }
    }
  ];
  const invoiceHandleChange = (
    invoiceNo: string,
    invoiceDate: string
  ) => () => {
    const clickedCategory = checked.indexOf(invoiceNo);

    if (clickedCategory === -1) {
      const obj = {
        invoiceNo,
        invoiceDate
      };
      all.push(obj);
    } else {
      console.log('Elseblock');
    }

    setChecked(all);
  };

  const handlePagination = (newpage: number) => {
    // alert("Page Index Changed");
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    let orderStatus = '';
    if (props.filtervalues) {
      orderStatus = props.filtervalues.orderStatus;
    }
    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: sortFilter,
      orderStatus
    };
    if (newpage - 1 !== pagenumber) {
      setPagenumber(newpage - 1);
      const newPagination = {
        page: newpage - 1,
        size: pagesize
      };
      setCSCPDetails(true);
    }
  };
  const handleSorting = (newSort: any) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    let orderStatus = '';
    if (props.filtervalues) {
      orderStatus = props.filtervalues.orderStatus;
    }

    const filters: any = props.filtervalues;
    filters.sort = newSort;
    setPagenumber(0);
    const newPagination = {
      pageNumber: 0,
      pageSize: pagesize
    };

    const activeAccount = localStorage.getItem('activeAccount');

    iObjCSService
      .getClaimStatusHistory(activeAccount, filters, newPagination)
      .then((response: any) => {
        // console.log(response.data);
        const resData = response.data;
        // console.log(resData, 'from handlesorting');
        // props.pagination.totalItems=response.totalClaims;
        setTotalItems(response.totalClaims);
        setTotalPages(response.totalPages);

        setClaimStatusHistoryData(resData);
        handleApiLoader(false);
      })
      .catch(error => {
        console.log(error);
        setClaimStatusHistoryData([]);
        handleApiLoader(false);
      });
  };
  const handlePageSizeChange = (pageSizeVal: any) => {
    // alert("Page Size Changed");
    // alert(pageSizeVal);

    const { filtervalues } = props;
    setPageSize(pageSizeVal);
    setPagenumber(0);
    setUCSCPagesize(true);
  };
  const handleMenuItemClick = (event: any, index: number) => {
    const { filtervalues, pagination } = props;
    // setSelectedIndex(index);
    setAnchorEl(null);

    setShowLoaderOnAction(true);
    if (
      exportOptions[index].value === 'pdf' ||
      exportOptions[index].value === 'pdf1'
    ) {
      setExptOption(exportOptions[index].value);
    } else if (exportOptions[index].value === 'xlsx') {
      setExptOption(exportOptions[index].value);
    } else if (exportOptions[index].value === 'csv') {
      setExptOption(exportOptions[index].value);
    }
    setShowLoaderOnAction(false);
  };

  const onClickInvoiceNo = (invoiceNo: string) => {
    setShowLoaderOnAction(true);

    const activeAccount = localStorage.getItem('activeAccount');
    iObjCSService
      .getClaimInvoiceDateByInvNo(activeAccount, invoiceNo)
      .then((ivDateResp: any) => {
        // console.log(ivDateResp);
        const invoiceDt: string = ivDateResp.data.data;
        InvoiceService.downloadInvoice(invoiceNo, invoiceDt)
          .then((response: any) => {
            setHideBtnShowError(false);
            setShowLoaderOnAction(false);
            downloadFile(
              response.data,
              `invoice-${invoiceNo}-${LocaleFormating.getNowDate('short')}.pdf`
            );
          })
          .catch(error => {
            console.log(error);
            setHideBtnShowError(true);
            setShowLoaderOnAction(false);
          });
        // setClaimStatusHistoryData(resData);
        handleApiLoader(false);
      })
      .catch((error: any) => {
        // console.log(error);
        // handleApiLoader(false);
        // removeColumnOrganiser();
        setClaimStatusHistoryData([]);
      });
  };
  const onClickPaymentReference = (tablemeta: any) => {
    const ClaimNo: any = [];
    ClaimNo.push({ claimNumber: tablemeta });
    // debugger;
    iObjCSService
      .downloadClaimConfirmation(ClaimNo)
      .then((response: any) => {
        setshowSaveError(false);
        setShowLoaderOnAction(false);
        if (response.status === 206) {
          setshowSaveError(true);
        }

        downloadFile(
          response.data,
          `Claim${LocaleFormating.getNowDate('short')}.pdf`
        );
      })
      .catch(error => {
        console.log(error);
        setshowSaveError(true);
        setShowLoaderOnAction(false);
      });
  };

  const paymentHistoryDataMapping = (data: any[]) => {
    const paymentHistoryDataMap: any[] = [];
    data.forEach(sel => {
      let creditMapped = {};
      // let exestingCreditMapped: any[] = [];
      const key = 'checkedstatus';
      const value = false;
      const jSel = JSON.parse(JSON.stringify(sel));
      Object.assign(jSel, { checkedstatus: false, Ischeckedind: '' });

      // console.log(jSel,'jsel');
      const isExist = paymentHistoryDataMap.filter(
        a => a.transactionId === sel.transactionId.toString()
      );
      if (isExist.length > 0) {
        // exestingCreditMapped = isExist[0]['mappedPayment'];
        // exestingCreditMapped.push(jSel);
        isExist[0]['csPartDetails'].push(jSel);
        // isExist[0]['amountPaid'] = (
        //   isExist[0]['amountPaid'] / 1 +
        //   jSel.amountPaid / 1
        // ).toString();
        isExist[0]['number'] = jSel.number
          ? jSel.number.substring(jSel.number.length - 4, jSel.number.length)
          : isExist[0]['number']
          ? isExist[0]['number'].substring(
              isExist[0]['number'].length - 4,
              isExist[0]['number'].length
            )
          : '';
        creditMapped['isSelected'] = false;
        creditMapped['indvalchecked'] = '';
        // creditMapped['checkedstatus'] = false;
      } else {
        creditMapped = JSON.parse(JSON.stringify(sel));
        creditMapped['csPartDetails'] = [jSel];
        creditMapped['number'] = jSel.number
          ? jSel.number.substring(jSel.number.length - 4, jSel.number.length)
          : '';
        creditMapped['isSelected'] = false;
        creditMapped['indvalchecked'] = '';
        // creditMapped['checkedstatus'] = false;
        paymentHistoryDataMap.push(creditMapped);
      }
    });

    return paymentHistoryDataMap;
  };

  const handleDownloadListItemInvoice = () => {
    if (checked && checked.length > 0) {
      const selectedInvoices: any[] = [];
      // const selectedInvoiceList: string[] = [];
      checked.map((sel: any) => {
        const isExist = selectedInvoices.filter(
          a => a.invoiceNo === sel.invoiceNo.toString()
        );
        if (isExist.length === 0) {
          selectedInvoices.push({
            invoiceNo: sel.invoiceNo.toString(),
            invoiceDate: sel.invoiceDate.toString()
          });
          // selectedInvoiceList.push(sel.invoiceNumber.toString());
        }
      });

      if (selectedInvoices && selectedInvoices.length > 0) {
        setShowLoaderOnAction(true);
        InvoiceService.downloadInvoices(selectedInvoices)
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setShowInvoiceError(false);
            if (response.status === 206) {
              setShowInvoiceError(true);
            }
            if (selectedInvoices.length === 1) {
              downloadFile(
                response.data,
                `invoice-${checked[0].invoiceNo}-${LocaleFormating.getNowDate(
                  'short'
                )}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `invoices${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          })
          .catch(error => {
            // console.log(error);
            setShowInvoiceError(true);
            setShowLoaderOnAction(false);
          });
      }
    }
  };
  const removeClaimsFromSelectedVal = (select: any) => {
    // console.log('removeClaimsFromSelectedVal>>>>>>', select);
  };
  const getEmailModalclaims = () => {
    return (
      <React.Fragment>
        <div className="send-email-desktop">
          {modalIsOpen ? (
            <Modal showClose={true} handleCloseModal={closeEmailModal}>
              {/* <EmailClaimsModal
                selectedClaims={allSelectedData}
                removeClaimsFromSelected={removeClaimsFromSelectedVal}
                
                closeModal={closeEmailModal}
              /> */}
            </Modal>
          ) : (
            <React.Fragment />
          )}
        </div>
      </React.Fragment>
    );
  };
  const [
    removeInvoiceFromSelected,
    setRemoveInvoiceFromSelected
  ] = React.useState([]);
  const getEmailModal = () => {
    return (
      <React.Fragment>
        <div className="send-email-desktop">
          {modalIsOpen ? (
            <Modal showClose={true} handleCloseModal={closeEmailModal}>
              <EmailClaimsModal
                allSelectedData={csPDFAvailData}
                removeClaimsFromSelected={removeClaimsFromSelectedVal}
                closeModal={closeEmailModal}
                csPartExpCols={csPartExpCols}
                csColumns={columns1}
                csPDFErrMsg={errormsg}
              />
            </Modal>
          ) : (
            <React.Fragment />
          )}
        </div>
      </React.Fragment>
    );
  };
  const openEmailModal = () => {
    setShowLoaderOnAction(true);

    const strClaims: any[] = [];
    let i: number = 0;
    for (i = 0; i < allSelectedData.length; i++) {
      strClaims.push(allSelectedData[i].claimNo);
    }
    // console.log(strClaims);
    if (strClaims && strClaims.length > 0) {
      iObjCSService.gClaimConfirmation(strClaims).then((cpdfResp: any) => {
        const claimsPdfs: any[] = [];
        setShowLoaderOnAction(false);

        const feClaims: any[] = [];
        for (i = 0; i < cpdfResp.claimsHavePdf.length; i++) {
          const cPdf = allSelectedData.find(
            p => p.claimNo === cpdfResp.claimsHavePdf[i]
          );
          if (cPdf) {
            feClaims.push(cPdf);
          }
          claimsPdfs.push({ claimNumber: cpdfResp.claimsHavePdf[i] });
        }
        const claimswithNoPdfs: any[] = [];

        for (i = 0; i < cpdfResp.claimsWithNoPdf.length; i++) {
          claimswithNoPdfs.push(cpdfResp.claimsWithNoPdf[i]);
        }

        if (claimswithNoPdfs.length > 0) {
          setShowLoaderOnAction(false);
          setshowNoClaimsError(true);

          seterrormsg(
            'The following claims: ' +
              claimswithNoPdfs.join(', ') +
              ' do not have claim confirmation receipt.'
            // 'We are currently generating your claim confirmation receipt for selected claims:' +
            //   claimswithNoPdfs.join(', ') +
            //   '. Please allow a few minutes and try again. If you continue to receive this message, please contact'
          );
        } else {
          seterrormsg('');
        }

        if (claimsPdfs && claimsPdfs.length === 0) {
          setShowLoaderOnAction(false);
          setshowNoClaimsError(true);
        } else if (claimsPdfs && claimsPdfs.length > 5) {
          setshowNoClaimsError(false);
          setshowEmailError(true);
          setshowEmailmsg(true);
        } else if (claimsPdfs && claimsPdfs.length <= 5) {
          setcsPDFAvailData(feClaims);
          setshowEmailError(false);
          setshowNoClaimsError(false);
          setModalIsOpen(true);
          window.scrollTo(0, 0);
          disableScroll();
        } else {
          setshowEmailError(true);
        }
      });
    }
  };
  const closeEmailModal = () => {
    setModalIsOpen(false);
    enableScroll();
  };
  const handleDownloadListItem = () => {
    if (allSelectedData && allSelectedData.length > 0) {
      // debugger;
      const selectedClaims: any[] = [];
      allSelectedData.map(sel => {
        const isExist = selectedClaims.filter(
          a => a.claimNumber === sel.claimNo.toString()
        );
        if (isExist.length === 0) {
          selectedClaims.push({
            claimNumber: sel.claimNo.toString()
          });
        }
      });
      setShowLoaderOnAction(true);
      const strClaims: any[] = [];
      let i: number = 0;
      for (i = 0; i < selectedClaims.length; i++) {
        strClaims.push(selectedClaims[i].claimNumber);
      }
      // console.log(strClaims);
      if (strClaims && strClaims.length > 0) {
        iObjCSService.gClaimConfirmation(strClaims).then((cpdfResp: any) => {
          const claimsPdfs: any[] = [];
          const claimswithNoPdfs: any[] = [];
          for (i = 0; i < cpdfResp.claimsHavePdf.length; i++) {
            claimsPdfs.push({ claimNumber: cpdfResp.claimsHavePdf[i] });
          }
          for (i = 0; i < cpdfResp.claimsWithNoPdf.length; i++) {
            claimswithNoPdfs.push(cpdfResp.claimsWithNoPdf[i]);
          }
          setshowNoClaimsError(false);
          if (claimsPdfs && claimsPdfs.length === 0) {
            setShowLoaderOnAction(false);
            setshowNoClaimsError(true);
          }

          if (claimswithNoPdfs.length > 0) {
            setShowLoaderOnAction(false);
            setshowNoClaimsError(true);
            seterrormsg(
              'We are currently generating your claim confirmation receipt for selected claims:' +
                claimswithNoPdfs.join(', ') +
                '. Please allow a few minutes and try again. If you continue to receive this message, please contact'
            );
          }

          if (claimsPdfs && claimsPdfs.length > 1) {
            iObjCSService
              .downloadClaimConfirmation(claimsPdfs)
              .then((response: any) => {
                setshowSaveError(false);
                setShowLoaderOnAction(false);
                if (response.status === 206) {
                  // setshowSaveError(true);
                  setshowNoClaimsError(true);
                }

                downloadFile(
                  response.data,
                  `Claim${LocaleFormating.getNowDate('short')}.zip`
                );

                /* if (selectedClaims.length === 1) {
                  downloadFile(
                    response.data,
                    `Claim-${selectedClaims[0].claimNumber}.pdf`
                  );
                } else {
                  downloadFile(
                    response.data,
                    `Claim${LocaleFormating.getNowDate('short')}.zip`
                  );
                } */
              })
              .catch(error => {
                // console.log(error);
                // setshowSaveError(true);
                setshowNoClaimsError(true);
                setShowLoaderOnAction(false);
              });
          }
          if (claimsPdfs && claimsPdfs.length === 1) {
            setShowLoaderOnAction(true);
            iObjCSService
              .downloadClaimConfirmation(claimsPdfs)
              .then((response: any) => {
                setshowSaveError(false);
                setShowLoaderOnAction(false);
                if (response.status === 206) {
                  // setshowSaveError(true);
                  setshowNoClaimsError(true);
                }

                downloadFile(
                  response.data,
                  `Claim${LocaleFormating.getNowDate('short')}.pdf`
                );
              })
              .catch(error => {
                // console.log(error);
                // setshowSaveError(true);
                setshowNoClaimsError(true);
                setShowLoaderOnAction(false);
              });
          }
        });
      }
    }
  };
  const handleClickListItem = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const ResubmitClaim = (cDetails: any) => {
    // console.log(cDetails);

    props.setcResubmitDetails(cDetails);
    props.SetResubmitClaim(true);
  };

  const printReceipt = () => {
    if (
      rowscount &&
      rowscount.length > 0 &&
      csHistoryData &&
      csHistoryData.length > 0
    ) {
      const invoicesNumber: string[] = [];
      rowscount.forEach(ele => {
        const indexVal = csHistoryData.findIndex(
          (val: any, i: any) => i === ele
        );
        invoicesNumber.push(csHistoryData[indexVal].invoiceNumber.toString());
      });
      if (invoicesNumber.length !== 0) {
        InvoiceService.downloadInvoices(invoicesNumber).then(
          (response: any) => {
            if (invoicesNumber.length === 1) {
              downloadFile(
                response.data,
                `invoice-${LocaleFormating.getNowDate('short')}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `invoices${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          }
        );
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf1' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
    // { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf1' }
  ];

  const csPartExpCols = [
    {
      label: `${i18n.t('CSPReport.csPartNo')}`,
      value: 'csPartNo',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.CSOriInvNo')}`,
      value: 'cspOriInvNo',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.cspCreditInvMemo')}`,
      value: 'cspInvoiceNo',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.cspQtyPartsOnClaim')}`,
      value: 'cspQtyPartsOnClaim',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.cspQtyCredited')}`,
      value: 'cspQtyCredited',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.cspUnitPrice')}`,
      value: 'cspUnitPrice',
      fVal: 'C'
    },
    {
      label: `${i18n.t('CSPReport.cspTotalPrice')}`,
      value: 'cspTotalPrice',
      fVal: 'C'
    },

    {
      label: `${i18n.t('CSPReport.cspAStatus')}`,
      value: 'cspAStatus',
      fVal: ''
    },
    {
      label: `${i18n.t('CSPReport.cspErrInfo')}`,
      value: 'cspErrInfo',
      fVal: ''
    }
  ];

  const gridOptions = {
    filter: false,
    // filterType: 'checkbox',
    search: false,
    download: false,
    disableToolbarSelect: true,
    expandableRowsOnClick: true,
    rowsSelected: rowscount,
    pagination: false,
    rowsPerPageOptions: [10, 20, 30, 40, 50],
    rowsPerPage: numberOfRowsPerPage,
    print: false,
    sort: true,
    expandableRows: true,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    rowsExpanded: rowsExpandedList,
    onRowClick: (rowData: any, rowState: any) => {
      // console.log(rowData, rowState, 'rowinfo');
    },
    onRowsSelect: (rowData: any, rowState: any) => {
      // console.log(rowData, rowState, 'rowinfo');
    },

    renderExpandableRow: (rowData: any, rowMeta: any) => {
      // console.log(rowData, rowMeta);
      const selectedCreditDataIndex = csHistoryData.findIndex(
        (el: any) => el.claimNo === rowData[7]
      );
      // console.log(selectedCreditDataIndex);
      const selectedCreditData =
        csHistoryData[selectedCreditDataIndex].csPartDetails;

      if (selectedCreditData && selectedCreditData.length > 0) {
        return (
          <>
            <TableRow className="CSPartTblRow">
              <TableCell
                colSpan={
                  columns1.filter(p => p.options.display === true).length + 2
                }
                style={{ padding: '0px ', paddingRight: '0px' }}
                className="TblCSPartDetails"
              >
                <div className="container divCSPDetails">
                  {selectedCreditData.map((val: any, index: any) => (
                    <div className="row row-col-2">
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.csPartNo')}</label>
                        {val.csPartNo}
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.CSOriInvNo')}</label>{' '}
                        <span
                          className="claim-desktop-row-line"
                          onClick={() => onClickInvoiceNo(val.cspOriInvNo)}
                        >
                          {val.cspOriInvNo}
                        </span>
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspCreditInvMemo')}</label>{' '}
                        <span
                          className="claim-desktop-row-line"
                          onClick={() => onClickInvoiceNo(val.cspInvoiceNo)}
                        >
                          {val.cspInvoiceNo}
                        </span>
                      </div>

                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspQtyPartsOnClaim')}</label>
                        &nbsp;{val.cspQtyPartsOnClaim}
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspQtyCredited')}</label>
                        &nbsp;{val.cspQtyCredited}
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspUnitPrice')}</label>&nbsp;
                        {currencyFormatter(val.cspUnitPrice)}
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspTotalPrice')}</label>&nbsp;
                        {currencyFormatter(val.cspTotalPrice)}
                      </div>

                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspAStatus')}</label>&nbsp;
                        {val.cspAStatus}
                      </div>
                      <div className="col-md-8 col-sm-8 col-lg-4 cspColumn">
                        <label>{i18n.t('CSPReport.cspErrInfo')}</label>&nbsp;
                        {val.cspErrInfo}
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4 cspColumn">
                        <>
                          <label>&nbsp;</label>

                       {val.claimTypeShortCode==="PackC" || 
                        val.claimTypeShortCode==="PartM" || 
                        val.claimTypeShortCode==="PartZ" || 
                        val.claimTypeShortCode==="PartU" || 
                        val.claimTypeShortCode==="PartE"  ?
                        (
                          <span
                                className="claim-desktop-row-line"
                              />
                        )
                        :
                        (
                          (val.claimSource === 'Website' || val.claimSource === 'NS3') &&  
                          val.cspAStatus === 'Rejected' &&
                          val.cspErrInfo !== '' &&
                          !val.cspRClaimRefNo &&
                          <span
                                className="claim-desktop-row-line"
                                onClick={() => ResubmitClaim(val)}
                              >
                              {i18n.t('CSPReport.csResubmitLink')}
                              </span>

                        )
                        }
                          {val.cspRClaimRefNo && (
                            <>
                              {i18n.t('CSPReport.csResubmitText')}{' '}
                              {val.cspRClaimRefNo}
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  ))}
                </div>

                <Table className="MuiTable-root tblCSPDetails">
                  <thead>
                    <TableRow className="MuiTableRow-root">
                      <TableCell className="cspTblColumn">
                        {' '}
                        {i18n.t('CSPReport.csPartNo')}
                      </TableCell>
                      <TableCell className="cspTblColumn">
                        {i18n.t('CSPReport.CSOriInvNo')}
                      </TableCell>
                      <TableCell className="cspTblColumn">
                        {i18n.t('CSPReport.cspCreditInvMemo')}
                      </TableCell>
                      <TableCell className="cspTblColumn">
                        {' '}
                        {i18n.t('CSPReport.cspQtyPartsOnClaim')}
                      </TableCell>
                      <TableCell className="cspTblColumn">
                        {' '}
                        {i18n.t('CSPReport.cspQtyCredited')}
                      </TableCell>

                      <TableCell className="cspTblColumn">
                        {' '}
                        {i18n.t('CSPReport.cspUnitPrice')}
                      </TableCell>
                      <TableCell className="cspTblColumn">
                        {i18n.t('CSPReport.cspTotalPrice')}
                      </TableCell>

                      <TableCell className="cspTblColumn">
                        {' '}
                        {i18n.t('CSPReport.cspAStatus')}
                      </TableCell>
                      <TableCell className="cspTblColumnAW">
                        {' '}
                        {i18n.t('CSPReport.cspErrInfo')}
                      </TableCell>
                      <TableCell className="cspTblColumn" />
                    </TableRow>
                  </thead>
                  <tbody>
                    {selectedCreditData.map((val: any, index: any) => (
                      <TableRow className="paymentTable-subtable">
                        <TableCell className="cspTblColumn">
                          {val.csPartNo==="STS  14-0352-01" ?  `${val.csPartNo} (Misc)`
                          :
                          val.csPartNo==="STS  14-0353-01" ?  `${val.csPartNo} (Travel)`
                          :
                          val.csPartNo==="STS  14-0372-01" ?  `${val.csPartNo} (Labor)`
                          :
                          val.csPartNo
                          }
                        </TableCell>
                        <TableCell className="cspTblColumn">
                          <span
                            className="claim-desktop-row-line"
                            onClick={() => onClickInvoiceNo(val.cspOriInvNo)}
                          >
                            {val.cspOriInvNo}
                          </span>
                        </TableCell>
                        <TableCell className="cspTblColumn">
                          <span
                            className="claim-desktop-row-line"
                            onClick={() => onClickInvoiceNo(val.cspInvoiceNo)}
                          >
                            {val.cspInvoiceNo}
                          </span>
                        </TableCell>

                        <TableCell className="NumericCol cspTblColumn">
                          {val.cspQtyPartsOnClaim}
                        </TableCell>
                        <TableCell className="NumericCol cspTblColumn">
                          {val.cspQtyCredited}
                        </TableCell>
                        <TableCell className="NumericCol cspTblColumn">
                          {currencyFormatter(val.cspUnitPrice)}
                        </TableCell>
                        <TableCell className="NumericCol cspTblColumn">
                          {currencyFormatter(val.cspTotalPrice)}
                        </TableCell>

                        <TableCell className="cspTblColumn">
                          {val.cspAStatus}
                        </TableCell>
                        <TableCell className="cspTblColumnAW">
                          {val.cspErrInfo}
                        </TableCell>
                        {val.claimTypeShortCode==="PackC" || 
                        val.claimTypeShortCode==="PartM" || 
                        val.claimTypeShortCode==="PartZ" || 
                        val.claimTypeShortCode==="PartU" || 
                        val.claimTypeShortCode==="PartE"  ?
                        (
                          <TableCell className="cspTblColumn"/>
                        )
                        :
                        <TableCell className="cspTblColumn">
                          {(val.claimSource === 'Website' ||
                            val.claimSource === 'NS3') &&
                            val.cspAStatus === 'Rejected' &&
                            val.cspErrInfo !== '' &&
                            !val.cspRClaimRefNo && (
                              <span
                                className="claim-desktop-row-line"
                                onClick={() => ResubmitClaim(val)}
                              >
                               {i18n.t('CSPReport.csResubmitLink')}
                              </span>
                            )}
                          {val.cspRClaimRefNo && (
                            <>
                              {i18n.t('CSPReport.csResubmitText')}{' '}
                              {val.cspRClaimRefNo}
                            </>
                          )}
                        </TableCell>
                      }
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
              </TableCell>
            </TableRow>
          </>
        );
      }
      return null;
    },
    onRowExpansionChange: (
      curExpanded: any,
      allExpanded: any[],
      rowsExpanded: any
    ) => {
      setRowsExpandedList(allExpanded.map(a => a.dataIndex));
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      setNumberOfRowsPerPage(numberOfRows);
    },
    draggableColumns: {
      enabled: true,
      transitionTime: 300
    },
    sortOrder: sortOrderState as any,
    onRowSelectionChange,
    customToolbarSelect: () => <CustomToolbar />,
    customToolbar: () => (
      <MuiThemeProvider theme={theme}>
        <span className="export-icon">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClickListItem}
            disabled={!allSelectedData.length && !csHistoryData.length}
          >
            <img className="image-icon" src={exportIcon} />
            <img className="down-arrow" src={downarrowIcon} />
          </Button>
        </span>
        <span className="export-icon save-icon">
          <Button
            onClick={handleDownloadListItem}
            disabled={!allSelectedData.length}
          >
            <Tooltip
              title={i18n.t('claimStatus.csConfirmationDownload')}
              placement="bottom"
            >
              <img className="image-icon" src={saveFileIcon} />
            </Tooltip>
          </Button>
        </span>
        <span className="export-icon save-icon">
          <Button onClick={openEmailModal} disabled={!allSelectedData.length}>
            <Tooltip title={i18n.t('common.sendEmail')} placement="bottom">
              <img className="image-icon" src={EmailIcon} />
            </Tooltip>
          </Button>
        </span>
        {/* <span className="download-wrapper">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={printReceipt}
            disabled={!rowscount.length}
          >
            <img className="download-icon" src={paymentHistoryDownload} />
          </Button>
        </span> */}
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted={true}
          open={Boolean(anchorEl)}
          TransitionComponent={Fade}
          onClose={handleClose}
        >
          {exportOptions.map((exportoptions, index) => (
            <MenuItem
              key={exportoptions.value}
              // selected={index === index}
              onClick={event => handleMenuItemClick(event, index)}
            >
              {exportoptions.label}
            </MenuItem>
          ))}
        </Menu>

        <div className="rp-product-status--paginator">
          <CustomPaginator
            activePage={pagenumber ? pagenumber + 1 : 1}
            totalPages={totalPages}
            itemsPerPage={pagesize ? pagesize : 20}
            onPageChanged={handlePagination}
            totalItems={totalItems ? totalItems : 0}
            showPageInfo={true}
            onPageSizeChange={handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={pagesize ? pagesize : 20}
          />
        </div>
        <React.Fragment>
          {hideBtnShowError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setHideBtnShowError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                <div className="error-message-to-show">
                  {i18n.t('invoices.downloaderror')}
                </div>
              </div>
            </Alert>
          ) : (
            ''
          )}
          {showPaymentError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setShowPaymentError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message13')}
                    <a href="mailto:reliablepartsar1@reliableparts.com">
                      reliablepartsar1@reliableparts.com
                    </a>{' '}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message13')}
                    <a href="mailto:accounts.receivable.us@reliableparts.com">
                      accounts.receivable.us@reliableparts.com
                    </a>{' '}
                  </div>
                )}
              </div>
            </Alert>
          ) : (
            ''
          )}
          {showEmailError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setshowEmailError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.emailErrorMessage')}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.emailErrorMessage')}
                  </div>
                )}
              </div>
            </Alert>
          ) : (
            ''
          )}
          {showSaveError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setshowSaveError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.saveClaimError')}
                    <a href="mailto:FeedbackCA@reliableparts.com.">
                      FeedbackCA@reliableparts.com.
                    </a>{' '}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.saveClaimError')}
                    <a href="mailto:FeedbackCA@reliableparts.com.">
                      FeedbackCA@reliableparts.com.
                    </a>{' '}
                  </div>
                )}
              </div>
            </Alert>
          ) : (
            ''
          )}
          {showNoClaimsError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setshowNoClaimsError(false);
                    setshowEmailmsg(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {showEmailmsg ? (
                  <div className="error-message-to-show">{errormsg}</div>
                ) : (
                  <div className="error-message-to-show">
                    {errormsg}
                    <a href="mailto:FeedbackCA@reliableparts.com.">
                      FeedbackCA@reliableparts.com.
                    </a>{' '}
                  </div>
                )}
              </div>
            </Alert>
          ) : (
            ''
          )}
        </React.Fragment>
        {allSelectedData.length > 0 && <CustomToolbar />}
      </MuiThemeProvider>
    ),
    onViewColumnsChange: (changedColumn: any, action: any) => {
      setCSGridColDisplayStatus(changedColumn, action);
    },
    onColumnSortChange: (changedColumn: any, direction: string) => {
      const dir = direction;
      // changedColumn=columns1;
      setSortOrderState({ name: changedColumn, direction: dir });
      handleSorting({ type: changedColumn, order: dir });
    },
    onColumnVisibilityChange: (params: any, event: any, details: any) => {
      // console.log(params, event, details.api.getVisibleColumns());
    },
    textLabels: {
      body: {
        noMatch: `${i18n.t('claimStatus.DataNotFound01')}`,
        toolTip: `${i18n.t('invoices.sort')}`
      },
      pagination: {
        next: `${i18n.t('invoices.nextPage')}`,
        previous: `${i18n.t('invoices.previousPage')}`,
        rowsPerPage: `${i18n.t('invoices.rowsperpage')}`,
        displayRows: `${i18n.t('invoices.of')}`
      }
    }
  };

  function Table2CSV(table: any) {
    // Query all rows
    const rows = table.querySelectorAll('tr');

    return [].slice
      .call(rows)
      .map((row: any) => {
        // Query all cells
        const cells = row.querySelectorAll('th,td');
        return [].slice
          .call(cells)
          .map((cell: any) => {
            return cell.textContent;
          })
          .join(',');
      })
      .join('\n');
  }

  function createXMLTable(table: any, fileName: any) {
    const xmlTable = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
       xmlns="http://www.w3.org/TR/REC-html40"
        >
           <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
           <head>
              <xml>
                <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                        <x:ExcelWorksheet>
                            <x:Name>${fileName}</x:Name>
                            <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                        </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
           </head>
           <body>
             ${table}
           </body>
        </html> `;
    return xmlTable;
  }

  /* function ExportToExcel(type:any, fn?:any, dl?:any) {
    const elt = document.getElementById('tblExpt');
    debugger;
    const wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
    return dl ?
      XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
      XLSX.writeFile(wb, fn || ('MySheetName.' + (type || 'xlsx')));
 } */

  function createFileUrl(xmlTable: any, fName: string) {
    const tableBlob = new Blob([xmlTable], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
    });
    const downloadURL = URL.createObjectURL(tableBlob);
    downloadFile(tableBlob, fName);
  }
  function createPDFFileUrl(xmlTable: any) {
    const tableBlob = new Blob([xmlTable], { type: 'application/pdf,' });
    const downloadURL = URL.createObjectURL(tableBlob);
    // console.log(downloadURL);
    const fName = `Claim Status-${LocaleFormating.getNowDate('short')}.pdf`;
    downloadFile(xmlTable, fName);
    // return downloadURL;
  }

  React.useEffect(() => {
    // alert(ExptOption);
    const id = 'tblExpt';
    const a = document.createElement('a');

    const tablediv = document.getElementById(id);
    let fName = `Claim Status-${LocaleFormating.getNowDate('short')}`;
    if (ExptOption === 'csv') {
      fName = fName + `.csv`;
      const csv = Table2CSV(tablediv);
      // console.log(csv);
      const csvBlobObj = new Blob([csv], { type: 'text/csv' });
      downloadFile(csvBlobObj, fName);
    } else if (ExptOption === 'xlsx') {
      fName = fName + `.xls`;
      const xmlTable = createXMLTable(tablediv.outerHTML, fName);
      createFileUrl(xmlTable, fName);
      // ExportToExcel("xlsx")
    } else if (ExptOption === 'pdf1') {
      setShowLoaderOnAction(true);
      fName = fName + `.pdf`;
      const doc = new jsPDF('p', 'pt');
      // doc.html($("#tblExpt tr")[0]);
      // alert($($("#dvExpt table")[0]).attr("id"))
      // alert($("#dvExpt table").length)
      let finalY = 0;
      $('#dvExpt table').each((idx: any) => {
        const tblIdx: string = $($('#dvExpt table')[idx]).attr('id');
        autoTable(doc, {
          html: '#' + tblIdx,
          theme: 'grid',
          margin: {
            top: 20,
            bottom: 20
          },
          pageBreak: 'avoid',
          rowPageBreak: 'avoid',
          startY: finalY + (idx % 2 === 0 ? 5 : 0),
          styles: { valign: 'middle', halign: 'center' },
          headStyles:
            idx % 2 === 0
              ? { fillColor: [22, 88, 160], fontStyle: 'bold' }
              : { fillColor: [178, 178, 178], fontStyle: 'bold' },
          alternateRowStyles: { fillColor: [255, 255, 255] }
          // ,tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
        });
        finalY = (doc as any).lastAutoTable.finalY;
      });

      doc.save(fName);
      setShowLoaderOnAction(false);
    } else if (ExptOption === 'pdf') {
      setShowLoaderOnAction(true);

      fName = fName + `.pdf`;
      const pdf = html2PDF(tablediv, {
        jsPDF: {
          unit: 'px',
          format: 'a4'
        },
        imageType: 'image/webp',
        imageQuality: 1,
        output: fName,
        pagebreak: { mode: ['css', 'legacy', 'break-before'] },
        margin: {
          top: 20,
          right: 20,
          bottom: 20,
          left: 20
        }
      });
      setShowLoaderOnAction(false);
    }
    setExptOption('');
  }, [ExptOption, csHistoryData]);
  return (
    <React.Fragment>
      <div className="section-loader">
        {showLoaderOnAction ? (
          <div className="loader-container">
            <div className="loader-content">
              {i18n.t('invoices.pleasewaitwhileweareprocessingyourrequest')}
            </div>
            <div className="loader" />
          </div>
        ) : (
          <></>
        )}
        {apiLoader ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          <div className="csDesktopHistory" id="divCSHistory">
            <MuiThemeProvider theme={theme}>
              <MUIDataTable
                title={''}
                data={csHistoryData.map((item: any) => {
                  return [
                    item.claimNo,
                    // getDateFormat(item.paymentDate),
                    item.claimType,
                    item.claimSubmitted,
                    // item.paymentDescription,
                    item.claimOriInvNo,
                    item.claimSource,
                    item.claimStatus,
                    item.cRejectReason,
                    item.claimNo
                  ];
                })}
                columns={columns}
                options={gridOptions}
              />
            </MuiThemeProvider>
          </div>
        )}
      </div>
      {ExptOption && (
        <CSExpTblCmpt
          csColumns={columns1}
          csHistoryData={GetExportClaimDetails()}
          ExptOption={ExptOption}
          SltClaims={allSelectedData}
          csPartExpCols={csPartExpCols}
        />
      )}
      {csPDFAvailData && csPDFAvailData.length > 0 && getEmailModal()}
    </React.Fragment>
  );
}
